import {createContext} from 'react';

export const UserBookmarksContext = createContext(null);
